"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box/Box"));

var _excluded = ["children", "onChange", "value"];

var Select = _styledComponents["default"].select.withConfig({
  displayName: "RoundedDropdown__Select",
  componentId: "sc-1rvqng9-0"
})(["width:100%;height:46px;border-radius:10px;border:1px solid rgb(99,152,196)};position:relative;appearance:none;font-family:", ";font-size:", "px;font-weight:400;color:", ";line-height:1.75;letter-spacing:0.009375em;outline:0;text-overflow:ellipsis;padding-left:16px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.sansSerif;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes[4];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.dark[1];
});

var StyledWrapper = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "RoundedDropdown__StyledWrapper",
  componentId: "sc-1rvqng9-1"
})(["position:relative;width:", ";&:before{content:\"", "\";font-family:\"EngagingTechIcons\";font-size:14px;line-height:1;position:absolute;top:18px;right:16px;opacity:", ";z-index:1;pointer-events:none;}&:focus-within{&:before{transform:", ";}}"], function (_ref4) {
  var width = _ref4.width;
  return width || "826px";
}, function (_ref5) {
  var icon = _ref5.icon;
  return icon;
}, function (_ref6) {
  var isDisabled = _ref6.isDisabled;
  return isDisabled ? 0.6 : 1;
}, function (_ref7) {
  var noRotate = _ref7.noRotate;
  return noRotate ? "none" : "rotate(180deg)";
});

var RoundedDropdown = function RoundedDropdown(_ref8) {
  var children = _ref8.children,
      onChange = _ref8.onChange,
      value = _ref8.value,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref8, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, (0, _extends2["default"])({
    icon: "arrow_drop_down"
  }, props), /*#__PURE__*/_react["default"].createElement(Select, {
    icon: "arrow_drop_down",
    onChange: onChange,
    value: value
  }, children));
};

var _default = RoundedDropdown;
exports["default"] = _default;